import { Navigate } from 'react-router-dom'

import { useUserContext } from '../../context/UserContext'
import { Auth } from '../../models/Auth'
import { UserType } from '../utils/Types'

export type PrivateRouteProps = {
    auth: Auth
    redirectPath?: string
    component: JSX.Element
    visibleTo?: string[]
}

function PrivateRoute({
    auth: Auth,
    redirectPath = '/login',
    component,
    visibleTo,
}: PrivateRouteProps): JSX.Element {
    const { user }: { user: UserType } = useUserContext()
    const isAuthenticated = Auth.getIsAuthenticated()

    const isVisibleTo = user?.userGroups?.some((group) =>
        visibleTo?.includes(group)
    )
    if (!isAuthenticated || !isVisibleTo) {
        return <Navigate to={redirectPath} />
    }

    return component
}

export default PrivateRoute
